import _ from 'lodash';
import { connect } from 'react-redux';
import { get, update, invalidate } from '../../modules/accounting/rackTransfer';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let rackTransfer;
	let rackTransferId;

	if (ownProps.rackTransfer) {
		rackTransfer = ownProps.rackTransfer;
	} else {
		rackTransferId = ownProps.rackTransferId
			? ownProps.rackTransferId
			: _.get(ownProps, ['match', 'params', 'rackTransferId']);
		rackTransfer = _.get(state.maps, ['rackTransfer', rackTransferId]);
	}

	return {
		rackTransfer,
		bulkCustomerMap: state.maps.bulkCustomer,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		carrierMap: state.maps.carrier,
		terminalMap: state.maps.terminal,
		supplierMap: state.maps.supplier,
		bulkFormulaMap: state.maps.bulkFormula,
		bulkDeliveryMap: state.maps.bulkDelivery,
		invoiceDocumentMap: state.maps.invoiceDocument,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getRackTransfer: get,
			updateRackTransfer: update,
			invalidateRackTransfer: invalidate,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
